import './accessibility';
import './alpine';
import './confirmation-modal';
import './remember-scroll-position';
import './tooltips';

if (!window.Turbo) {
  window.Turbo = require('@hotwired/turbo');
}
const Turbo = window.Turbo;

import 'alpine-turbo-drive-adapter';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
Alpine.plugin(focus);
window.Alpine = Alpine;
Alpine.start();
